var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGatedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 43.673 43.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gated_In",
    "data-name": "Gated In",
    transform: "translate(1130.373 -453.064)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "index",
    transform: "translate(-1111.269 465.109)",
    fill: "#ff7200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M236.824,218.334H219.391a1.245,1.245,0,0,1-1.245-1.245V204.636a6.234,6.234,0,0,1,6.226-6.226h7.471a6.234,6.234,0,0,1,6.226,6.226v12.453a1.245,1.245,0,0,1-1.245,1.245Zm-16.188-2.49h14.943V204.636a3.736,3.736,0,0,0-3.736-3.736h-7.471a3.736,3.736,0,0,0-3.736,3.736Z",
    transform: "translate(-216.901 -198.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M239.125,479.64a1.245,1.245,0,0,1-1.245-1.245V475.9a1.245,1.245,0,1,1,2.49,0V478.4a1.245,1.245,0,0,1-1.245,1.245Z",
    transform: "translate(-235.389 -457.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M475.911,479.64a1.245,1.245,0,0,1-1.245-1.245V475.9a1.245,1.245,0,1,1,2.49,0V478.4a1.245,1.245,0,0,1-1.245,1.245Z",
    transform: "translate(-457.233 -457.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M224.364,398.226h-4.981a1.245,1.245,0,1,1,0-2.49h4.981a1.245,1.245,0,1,1,0,2.49Z",
    transform: "translate(-216.893 -383.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M421.694,398.226h-4.981a1.245,1.245,0,1,1,0-2.49h4.981a1.245,1.245,0,1,1,0,2.49Z",
    transform: "translate(-401.77 -383.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M200.9,358.756h-1.245a1.245,1.245,0,1,1,0-2.49H200.9a1.245,1.245,0,0,1,0,2.49Z",
    transform: "translate(-198.413 -346.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M496.884,358.756h-1.245a1.245,1.245,0,1,1,0-2.49h1.245a1.245,1.245,0,0,1,0,2.49Z",
    transform: "translate(-475.715 -346.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "index-2",
    "data-name": "index",
    transform: "translate(-1130.373 453.064)",
    fill: "#ff7200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M197.663,245.8l-1.4-5.62a.724.724,0,0,0-.876-.529l-29.632,7.386a5.062,5.062,0,0,0-9.566,2.317v2.194a3.51,3.51,0,0,0,0,1.455v15.9a2.179,2.179,0,0,0-2.173,2.173v2.9a.724.724,0,0,0,.724.724h13.035a.724.724,0,0,0,.724-.724v-2.9a2.179,2.179,0,0,0-2.173-2.173V254.358l30.813-7.684a.7.7,0,0,0,.442-.326.732.732,0,0,0,.087-.55Zm-36.41-.065a3.6,3.6,0,0,1,3.034,1.673l-5.446,1.354a3.621,3.621,0,0,0-1.21.558,3.629,3.629,0,0,1,3.621-3.585Zm5.793,25.346v2.172H155.46v-2.172a.724.724,0,0,1,.724-.724h10.138a.724.724,0,0,1,.724.724Zm-2.172-12.31v1.448h-7.242v-1.448Zm-7.242-1.448v-2.1a3.573,3.573,0,0,0,2.962.565l4.28-1.064v2.6Zm7.242,4.345v7.242h-7.242v-7.242Zm4.722-9.617-9.349,2.332a2.173,2.173,0,1,1-1.05-4.215l10.927-2.723ZM173.81,251l-2.716.681.529-4.613,2.716-.674Zm4.215-1.05-2.716.681.529-4.613,2.716-.674Zm4.215-1.05-2.716.674.536-4.606,2.716-.68Zm4.222-1.05-2.716.674.529-4.606,2.716-.681Zm4.215-1.05-2.716.674.529-4.606,2.716-.681Zm1.5-.377.529-4.613,2.325-.579,1.05,4.215Z",
    transform: "translate(-154.011 -239.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M205.81,361.2h1.448v1.448H205.81Z",
    transform: "translate(-200.741 -349.303)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatedIn);
export default __webpack_public_path__ + "static/media/gatedIn.87ef7bb46f29284e73f23190ef446928.svg";
export { ForwardRef as ReactComponent };